import { Typography, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./dashboard.module.scss";
import {
  faCircleInfo,
  faArrowTrendUp,
  faEnvelope,
  faArrowTrendDown
} from "@fortawesome/free-solid-svg-icons";

const { Text } = Typography;

const TotalPieces: React.FC<any> = ({ dashboardData, filters }) => {
  const pieceTotal = dashboardData?.totalPieces?.value ?? 0;
  const previous = dashboardData?.totalPieces?.previousPeriod ?? 0;
  const percentageChange = previous !== 0 
      ? ((pieceTotal - previous) / previous) * 100
      : 0;
  const isIncrease = percentageChange >= 0;
  var isNotCustom = false;
  if(filters?.[1])
  {
    isNotCustom = true;
  }
  
  return (
    <div className={styles.cardHeader}>
      <Text
        type="secondary"
        strong
        className={styles.cardText}
      >
        <span className={styles.cardTextIcon}>
          <span className={styles.leadsMetricIconWrap}><FontAwesomeIcon icon={faEnvelope} style={{width: '18px', height: '18px'}}/></span>
          TOTAL # OF PIECES
        </span>
      </Text>

      <div className={styles.cardBody}>
        <Text className={styles.cardVal}>
          {pieceTotal.toLocaleString()}
        </Text>

        {isNotCustom && previous > 0 && (
          <Text 
            className={styles.cardFont}
            style={{ color: isIncrease ? "#16D761" : "#f3083b" }}
          >
            <FontAwesomeIcon
              icon={isIncrease ? faArrowTrendUp : faArrowTrendDown}
              style={{ marginRight: 4 }}
            />
            {(percentageChange < 0 ? "-" : "") + Math.abs(percentageChange).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}%
          </Text>
          )
        }
      </div>

      {isNotCustom && previous > 0 && (
        <Text type="secondary" className={styles.cardFooter}>
          {previous.toLocaleString()} Ordered Last Period
          <Tooltip title="Orders from the previous reporting period">
            <FontAwesomeIcon
              icon={faCircleInfo}
              className={`${styles.cardIcon} ${styles.cardIconMargin}`}
            />
          </Tooltip>
        </Text>
        )
      }
    </div>
  );
};

export default TotalPieces;
